import { useEffect, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { getDefaultTableConfig } from '@/components/eventComponent/';
import {
  ACCESSIBLE_SITES_SOURCE,
  WidgetConfigSiteTabbedShell,
} from '@/components/widgetConfigSiteTabbedShell/index.ts';
import { WidgetConfigModalProps } from '@/types.ts';

import { EventTableConfig } from '../types.ts';
import { EventTableConfigForm } from './eventTableConfigModalContent/EventTableConfigForm.tsx';

type EventTableConfigModalContentProps = WidgetConfigModalProps<EventTableConfig> & {
  defaultTableConfig?: EventTableConfig;
};

export const EventTableConfigModalContent = ({
  defaultTableConfig,
  onClose,
  onGoBack,
  onSave,
  setModalTitle,
  widgetId,
}: EventTableConfigModalContentProps) => {
  const { t } = useTranslation(['common', 'eventStream']);
  const defaultConfig = useMemo(
    () => defaultTableConfig ?? getDefaultTableConfig(t),
    [defaultTableConfig, t]
  );

  useEffect(() => {
    if (setModalTitle) {
      setModalTitle(t('eventStream:eventStream'));
    }
  }, [setModalTitle, t]);

  return (
    <WidgetConfigSiteTabbedShell
      source={ACCESSIBLE_SITES_SOURCE}
      widgetId={widgetId}
      showItemCount={false}
      onSave={onSave}
      onClose={onClose}
      onGoBack={onGoBack}
      showSave
      renderSitePanel={() => <EventTableConfigForm defaultConfig={defaultConfig} />}
    />
  );
};
